exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-dialog[data-v-3fed84da] {\n    width: 100%;\n    background: rgb(255, 255, 255);\n    padding: 1.5rem 2rem;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n    border-radius: 0.3rem;\n    -webkit-transition: 0.5s;\n    transition: 0.5s;\n}\n.modal-body[data-v-3fed84da] {\n    color: rgb(180, 180, 180);\n}\n.d-flex[data-v-3fed84da] {\n    display: -webkit-box;\n    display: flex;\n}\n.justify-content-center[data-v-3fed84da] {\n    -webkit-box-pack: center;\n            justify-content: center;\n}\n", ""]);

// exports
